export const REFERRAL_CODE_STORAGE_KEY = 'SUPPR_REFERRAL_CODE';

export function resolveReferralCode(
  current: string | null | undefined,
  stored: string | null | undefined,
): string | null {
  const normalizedCurrent = current?.trim();
  if (normalizedCurrent) return normalizedCurrent;

  const normalizedStored = stored?.trim();
  return normalizedStored || null;
}
